import { defineAsyncComponent } from 'vue'
export default {
  addin: defineAsyncComponent(() => import("/app/apps/web/app/layouts/addin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/apps/web/app/layouts/default.vue").then(m => m.default || m))
}